
import styled from 'styled-components';

import { Anchor as GrommetAnchor } from 'grommet';

const Anchor = styled(GrommetAnchor)`
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;

export default Anchor;



// WEBPACK FOOTER //
// ./src/app/components/Anchor.js